import FilterChipsContainer from "../FilterChipsContainer"
import { useState, useEffect, useRef } from "react"
import FilterOptionChip from "../filteroptionchip/FilterOptionChip"
import Sheet from 'react-modal-sheet';

export default function FilterModal(
    { isFilterModalOpen, filters, selectedFilterOptions, existingDistance, onApplyClick, onFilterModalDismiss, visitSelections }
) {

    const footerRef = useRef(null)
    const [enabledFilters, setEnabledFilters] = useState(selectedFilterOptions)
    const [isFilteringByDistance, setIsFilteringByDistance] = useState(existingDistance != null)
    const [selectedDistance, setSelectedDistance] = useState(existingDistance)
    const [selectedVisits, setSelectedVisits] = useState(visitSelections)
  
    useEffect( () => {
        setEnabledFilters(selectedFilterOptions)
    }, [selectedFilterOptions])

    useEffect( () => {
        setSelectedVisits(visitSelections)
    }, [visitSelections])

    useEffect( () => {
        console.log(`showing filter modal distance ${existingDistance}`)
        if (existingDistance) {
            setSelectedDistance(existingDistance)
            setIsFilteringByDistance(true)
        }
    }, [existingDistance])

    function onFilterOptionToggled(clickedOption) {
        console.log(`onClick ${clickedOption}`)
        let updatedFilterOptions
        if (enabledFilters.includes(clickedOption.id)) {
          updatedFilterOptions = enabledFilters.filter((filterOptionId) => filterOptionId !== clickedOption.id)
        } else {
          updatedFilterOptions = enabledFilters.concat([clickedOption.id])
        }
        setEnabledFilters(updatedFilterOptions)
    }

    function onFilerByDistanceChange(event) {
        const {checked} = event.target;
        console.log(`ischecked ${checked}`)
        if (checked && selectedDistance == null) {
            setSelectedDistance(100)
        }
        setIsFilteringByDistance(checked)
    }

    function onDistanceChange(event) {
        console.log(`onDistanceChange ${event.target.value}`)
        setSelectedDistance(event.target.value)
    }

    return <Sheet isOpen={isFilterModalOpen} onClose={() => {onFilterModalDismiss()}} onOpenEnd={() => {
    }} detent="content-height">
        <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content>
        <Sheet.Scroller draggableAt="both">
            <div className="p-0">
        <div className={`px-6`}>
            <div className="h-8"></div>
        {
            filters.map((filter) => {
                return <div className="mb-4">
                    <h3 className="font-bold text-lg font-titan">{filter.label}</h3>
                    <div className="pt-1">
                        {
                            filter.filterOptions.map((filterOption) => {
                                return <div className="form-control"
                                >
                                <label className="label cursor-pointer px-0">
                                    <span className="label-text text-base">{filterOption.label}</span> 
                                    {/* <input type="radio" name="radio-updated" className="radio checked:bg-primary" checked={enabledFilters.includes(filter.tag)} /> */}
                                    <input type="checkbox"  className="checkbox checked:bg-primary" checked={enabledFilters.includes(filterOption.id)} onChange={(e) => {onFilterOptionToggled(
                                        {
                                            label: filterOption.label,
                                            id: filterOption.id,
                                            isSelected: enabledFilters.includes(filterOption.id)
                                        }
                                    );}} />
                                </label>
                            </div>
                            })
                        }
                        {/* <FilterChipsContainer 
                            key={filter.id}
                            title={null}
                            filterOptions={filter.filterOptions.map((filterOption) => {
                                filterOption.isSelected = enabledFilters.includes(filterOption.id)
                                return filterOption
                            })}
                            onFilterOptionClick={onFilterOptionToggled}
                            /> */}
                    </div>
                </div>

            })
        }
        <div className="mb-4">
            <h3 className="font-bold text-lg font-titan">Distance</h3>
            <div className="form-control">
            <label className="label cursor-pointer">
                <span className="label-text text-base">Filter by distance from you</span> 
                <input type="checkbox" className="checkbox" checked={isFilteringByDistance} onChange={onFilerByDistanceChange}/>
            </label>
            </div>
            {
                isFilteringByDistance && <div className="pt-1">
                <input type="range" min="0" max="100" value={selectedDistance} className="range" onChange={onDistanceChange} />
                <span className="label-text text-base">{selectedDistance} km from you</span> 
                </div>
            }
        </div>
        <div className="h-24"></div>
        </div>
        <div className="modal-action absolute bottom-0 right-0 bg-base-100 w-full px-6 py-4" ref={footerRef}>
            <button className="btn" onClick={
                () => {
                    setEnabledFilters([])
                    setIsFilteringByDistance(false)
                    setSelectedDistance(null)
                    onApplyClick(
                        filters.flatMap((filter) => filter.filterOptions).map((option) => {
                            return {
                                ...option, isSelected: false
                            }
                        }),
                        null,
                        {
                            visited: false,
                            nonVisited: false,
                        }
                    )
                    onFilterModalDismiss()
                }
                }>Clear</button>
            <button className="btn btn-success text-success-content mr-2" onClick={
                () => {
                    console.log(`${isFilteringByDistance} ${selectedDistance}`)
                    let appliedDistance = null
                    if (isFilteringByDistance) {
                        appliedDistance = selectedDistance
                    }
                    onApplyClick(
                        filters.flatMap((filter) => filter.filterOptions).map((option) => {
                            option.isSelected = enabledFilters.includes(option.id)
                            return option
                        }),
                        appliedDistance,
                        selectedVisits,
                    )
                    // document.getElementById(modalId).close()
                    onFilterModalDismiss()
                }
                } >Apply
            </button>

            <button className="btn btn-circle btn-soft" onClick={
                    () => {
                        
                        setEnabledFilters(selectedFilterOptions)
                        // document.getElementById(modalId).close()
                        onFilterModalDismiss()
                    }
                    }>
                <svg className="fill-base-content w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.207 6.207a1 1 0 0 0-1.414-1.414L12 10.586 6.207 4.793a1 1 0 0 0-1.414 1.414L10.586 12l-5.793 5.793a1 1 0 1 0 1.414 1.414L12 13.414l5.793 5.793a1 1 0 0 0 1.414-1.414L13.414 12l5.793-5.793z"/></svg>
            </button>
        </div>
        </div>
        </Sheet.Scroller>
        </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={(_) => {
            onFilterModalDismiss()
        }}/>
    </Sheet>
}